import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'sera-footer-bar',
    templateUrl: './sera-footer-bar.component.html',
    styleUrls: ['./sera-footer-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraFooterBarComponent {
    constructor() {}

    @Input()
    style: {} = {};
}
